import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { useModal } from '../useModal'
import { HTMLOptions } from '../ModalHost'
import classNames from 'classnames'

type Props = {
  isOpen: boolean
  modalRoute?: boolean
  onClose?: () => void
  layoutId?: string
  children: React.ReactNode
  htmlOptions?: HTMLOptions
  key: string
}

const Modal = ({
  isOpen,
  children,
  key,
  layoutId,
  htmlOptions,
  modalRoute,
}: Props): JSX.Element => {
  const { closeModal } = useModal()

  useEffect(() => {
    if (modalRoute) {
      document.documentElement.style.overflow = 'hidden'

      return () => {
        document.documentElement.style.overflow = 'unset'
      }
    }
  }, [modalRoute])

  return (
    <div>
      {isOpen && (
        <motion.div
          key={key}
          layoutId={layoutId}
          className={'h-screen w-2/3 fixed top-0 right-0 z-[1000]'}>
          <motion.div
            key={`bg-${layoutId}`}
            className={
              'h-screen w-full fixed top-0 right-0 z-20 overscroll-contain bg-black/20'
            }
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.1 } }}
            transition={{ type: 'spring', stiffness: 170, damping: 26, mass: 1 }}
            onClick={() => closeModal()}
          />

          <motion.div
            key={`modal-${layoutId}`}
            className={classNames(
              `flex h-screen absolute top-0 right-0 bg-white z-50 overscroll-contain w-full`,
              {
                'max-w-[600px]': htmlOptions?.maxWidth === 600,
                'max-w-[800px]': htmlOptions?.maxWidth === 800,
                'max-w-[1024px]': htmlOptions?.maxWidth === 1024,
                'max-w-[1440px]':
                  htmlOptions?.maxWidth === 1440 || htmlOptions?.maxWidth === undefined,
              },
            )}
            initial={{ opacity: 1, x: '100%' }}
            animate={{ opacity: 1, x: 0, transition: { duration: 0.3 } }}
            exit={{ opacity: 1, x: '100%', transition: { duration: 0.3 } }}
            transition={{
              type: 'spring',
              stiffness: 170,
              damping: 26,
              mass: 1,
            }}>
            {children}
          </motion.div>
        </motion.div>
      )}
    </div>
  )
}

export default Modal
